import * as React from 'react';
import { withInjectedRootStore, RootStore } from '../../providers';
import { ColorTheme } from '../../types';
import { Theme } from '../../enums';

export interface GlobalStylesProps {
  rootStore: RootStore;
}

function convertHex(hex, opacity) {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r},${g},${b},${opacity / 100})`;
}

function generateInlineClasses(colorTheme: ColorTheme, currentTheme?: string): string {
  const backgroundColor = currentTheme === Theme.WixStudio ? colorTheme.secondaryColor : colorTheme.mainColor;
  return `.default-colors {
    color: ${colorTheme.mainColor} !important;
    background-color: #FFF !important;
  }
  .colors {
    color: ${colorTheme.mainColor} !important;
  }
  .secondary-colors {
    color: ${colorTheme.secondaryColor} !important;
  }
  .white-colors {
    color: #FFF !important;
  }
  .studio-selected {
    color: #000 !important;
  }
  .default-colors-hover:hover {
    color: #FFF !important;
    background-color: ${colorTheme.secondaryColor}  !important;
  }
  .color-hover:hover {
    color: ${colorTheme.mainColor} !important;
  }
  .bg-colors {
    background-color: ${backgroundColor} !important;
  }
  .bg-colors-third {
    background-color:${colorTheme.thirdColor} !important;
  }
  .bg-colors-hover:hover {
    background-color: ${colorTheme.secondaryColor} !important;
  }
  .bg-colors-after:after {
    background-color: ${backgroundColor} !important;
  }
  .border-color {
    border-color: ${backgroundColor} !important;
  }
  .box-shadow {
    box-shadow: 0px 0px 0px 2px ${backgroundColor
    }, 0px 7px 25px 0px rgba(0, 0, 0, 0.1);
  }
  .box-shadow-thin {
    box-shadow: 0px 0px 0px 1px ${convertHex(
      backgroundColor,
      60,
    )}, 0px 7px 25px 0px rgba(0, 0, 0, 0);
  }
  .box-shadow-thin:hover {
    box-shadow: 0px 0px 0px 1px ${convertHex(
      backgroundColor,
      100,
    )}, 0px 7px 25px 0px rgba(0, 0, 0, 0);
  }
  .border-color-after:after {
      border-top: 1px solid ${backgroundColor} !important;
      border-right: 1px solid ${backgroundColor} !important;
  }
  .background-color-product-hat-mobile {
     background: ${convertHex(colorTheme.mainColor, 12)};
  }
  .limited-time-offering-tooltip-mobile {
    background: ${convertHex(colorTheme.mainColor, 8)};
  }
  .tooltip-list {
    padding: 0 15px;
  }


  `;
}

const GlobalStylesComp: React.FunctionComponent<GlobalStylesProps> = ({
  rootStore,
}) => {
  const inlineClasses = generateInlineClasses(
    rootStore.appStore.appContext.theme,
    rootStore.appStore.appContext.pageMode?.theme
  );
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: inlineClasses,
      }}
    />
  );
};

export const GlobalStyles = withInjectedRootStore(GlobalStylesComp);
